<div class="countdown uppercase flex row wrap y-items-center x-content-center full-width">
  <p class="days inline-block margin-left-right-5">
    <span class="draw-ball inline-block circle">
      {{d}}
    </span>
    <span class="count-box block margin-top-5">
      <ng-container *ngIf="('lang' | translate) == 'en'">
        Days
      </ng-container>
      <ng-container *ngIf="('lang' | translate) == 'es'">
        Días
      </ng-container>
      <ng-container *ngIf="('lang' | translate) == 'pt'">
        Dias
      </ng-container>
    </span>
  </p>
  <p class="inline-block margin-left-right-5">
    <span class="draw-ball inline-block circle">
      {{h}}
    </span>
    <span class="count-box block margin-top-5">
      hrs
    </span>
  </p>
  <p class="inline-block margin-left-right-5">
    <span class="draw-ball inline-block circle">
      {{m}}
    </span>
    <span class="count-box block margin-top-5">
      min
    </span>
  </p>
  <p class="inline-block margin-left-right-5">
    <span class="draw-ball inline-block circle">
      {{s}}
    </span>
    <span class="count-box block margin-top-5">
      <ng-container *ngIf="('lang' | translate) == 'es' || ('lang' | translate) == 'pt'">
        Seg
      </ng-container>
      <ng-container *ngIf="('lang' | translate) == 'en'">
        Sec
      </ng-container>
    </span>
  </p>
</div>
